import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject } from 'rxjs'
import { map } from 'rxjs/operators'
import { Filedescription, FileDescription, Hash, JurisDictionCode, ClientFileScheduleAndContractInfoModel, ClientFileScheduleInfoModel } from './client.model';
import { AppConfig } from '../../../app.config';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { SessionStorageService } from '@core/services/session-storage/session-storage.service';
@Injectable({
  providedIn: 'root'
})
export class ClientfileschedulesService {

  public filedescriptions: Filedescription[] = [];
  public LVSCustomerNumbers: Hash[] = [];
  public processStatuses: Hash[] = [];
  public filestatus: Hash[] = [];
  public Urgency: Hash[] = [];
  public Impact: Hash[] = [];

  public JurisdictionCode: string[];

  duplicatevinchecks = [{
    "id": 0,
    "description": "False"
  }, {
    "id": 1,
    "description": "True"
  }, {
    "id": 2,
    "description": "Null"
  }];
  duplicatereferencechecks = [{
    "id": 0,
    "description": "False"
  }, {
    "id": 1,
    "description": "True"
  }, {
    "id": 2,
    "description": "Null"
  }];

  CurrentFileScheduleSubject: BehaviorSubject<ClientFileScheduleAndContractInfoModel>;
  CurrentFileSchedule$: Observable<ClientFileScheduleAndContractInfoModel>;
  CurrentClientFileScheduleSubject: BehaviorSubject<ClientFileScheduleInfoModel>;
  CurrentClientFileSchedule$: Observable<ClientFileScheduleInfoModel>;

  constructor(
    private http: HttpClient,
    private sessionStorageService: SessionStorageService,
    private toastrService: ToastrService) {
    setTimeout(() => {
      if (this.sessionStorageService.getItem('currentUser')) {
        this.CallFilestatus();
      }
    }, 2300);
  }

  GetJurisdictionCode(): Observable<string[]> {
    return this.http.get<any>('assets/data/data.json').pipe(map(data => {
      console.log("GetJurisdictionCode", data);
      this.JurisdictionCode = data.JurisdictionCode;
      return (data.JurisdictionCode || [])
    }));
  }

  GetUrgency(): Observable<Hash[]> {
    return this.http.get<any>('assets/data/data.json').pipe(map(data => {
      this.Urgency = data.Urgency;
      return (data.Urgency || [])
    }));
  }

  GetImpact(): Observable<Hash[]> {
    return this.http.get<any>('assets/data/data.json').pipe(map(data => {
      this.Impact = data.Impact;
      return (data.Impact || [])
    }));
  }

  GetDuplicateVINchecks(): Observable<any> {
    return of(this.duplicatevinchecks);
  }

  GetDuplicateRefChecks(): Observable<any> {
    return of(this.duplicatereferencechecks);
  }

  CallFileDescriptionapi(id: number): Observable<FileDescription[]> {
    return this.http.get<FileDescription[]>(`${AppConfig.settings.settings.apiEndpoint}api/Client/FileDescription/${id}`).pipe(map(data => {
      this.filedescriptions = data;
      return (data || [])
    }));
  }

  CallProcessStatuses(ClientFileinfoId: number): Observable<Hash[]> {
    return this.http.get<Hash[]>(`${AppConfig.settings.settings.apiEndpoint}api/Client/ProcessStatuses/${ClientFileinfoId}`).pipe(map(data => {
      this.processStatuses = data;
      return (data || [])
    }));
  }

  CallFilestatus(): Observable<Hash[]> {
    return this.http.get<Hash[]>(`${AppConfig.settings.settings.apiEndpoint}api/Client/FileStatuss`).pipe(map(data => {
      this.filestatus = data;
      return (data || [])
    }));
  }

  searchFileScheduleByClientId(payload: number): Observable<ClientFileScheduleAndContractInfoModel> {

    setTimeout(() => {
      this.CallFileDescriptionapi(payload);
    }, 2000);


    return this.http.get<ClientFileScheduleAndContractInfoModel>(`${AppConfig.settings.settings.apiEndpoint}api/Client/GetFileSchedulesContractInfo/${payload}`).pipe(map(data => {
      if (this.CurrentFileSchedule$) {
        this.CurrentFileScheduleSubject.next(data);
      }
      else {
        this.CurrentFileScheduleSubject = new BehaviorSubject<ClientFileScheduleAndContractInfoModel>(data);
        this.CurrentFileSchedule$ = this.CurrentFileScheduleSubject.asObservable();
      }
      return data;
    }));
  }

  getClientFileScheduleByClientAndFileType(clientid:number, filetypeid:number): Observable<ClientFileScheduleInfoModel[]>{
    return this.http.get<ClientFileScheduleInfoModel[]>(`${AppConfig.settings.settings.apiEndpoint}api/ClientFileInfo/GetClientFileScheduleInfo?clientInfoId=`+clientid+`&fileTypeId=`+filetypeid).pipe(map(data => {
       return data;
    }));

  }

  createFileSchedule(payload: ClientFileScheduleAndContractInfoModel): Observable<ClientFileScheduleAndContractInfoModel> {
    this.http.post<ClientFileScheduleAndContractInfoModel>(AppConfig.settings.settings.apiEndpoint + 'api/Client/InsertOrUpdateFileSchedulesAndContractInfo', payload).subscribe(data => {
      this.CurrentFileScheduleSubject.next(data);
      this.toastrService.success("Saved successfully.", "");
    });
    return this.CurrentFileSchedule$;
  }

  updateFileSchedule(payload: ClientFileScheduleAndContractInfoModel): Observable<ClientFileScheduleAndContractInfoModel> {
    this.http.post<ClientFileScheduleAndContractInfoModel>(`${AppConfig.settings.settings.apiEndpoint}api/Client/InsertOrUpdateFileSchedulesAndContractInfo`, payload).subscribe(data => {
      this.CurrentFileScheduleSubject.next(data);
      this.toastrService.success("Saved successfully.", "");
    });
    return this.CurrentFileSchedule$;
  }

  updateClientFileSchedule(payload: ClientFileScheduleInfoModel): Observable<ClientFileScheduleInfoModel> {
    return this.http.post<ClientFileScheduleInfoModel>(`${AppConfig.settings.settings.apiEndpoint}api/ClientFileInfo/InsertOrUpdateClientFileScheduleInfo`, payload).pipe(map(data => {
      this.CurrentClientFileScheduleSubject = new BehaviorSubject<ClientFileScheduleInfoModel>(data);
      this.CurrentClientFileSchedule$ = this.CurrentClientFileScheduleSubject.asObservable();
      this.toastrService.success("Saved successfully.", "");
      return data;
    }));
   
  }

  removeClientFileSchedule(scheduleid:number, updatedby:string): Observable<boolean>{
    return this.http.get<boolean>(AppConfig.settings.settings.apiEndpoint+'api/ClientFileInfo/DeleteClientFileScheduleInfo?clientfilescheduleid='+scheduleid+'&updatedby='+updatedby).pipe(map(data=>{
      console.log("Check delete return", data);
      if(data === true)
      {
        this.toastrService.success("Deleted Successfully.");         
      } 
      return data;   
    }));  
  }

}
